
import { SchoolTypeModel } from "@/models/academy.model";
import { parseJSON } from "jquery";
import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import { Action, Getter, State } from "vuex-class";

@Component
export default class SchoolType extends Vue {
  // ACTION
  @Action("actionLoadSchool", { namespace: "misc" })
  private actionLoadSchool: any;
  @Action("actionAddSchoolType", { namespace: "academy" })
  private actionAddSchoolType: any;

  // GETTER
  @Getter("arraySchoolType", { namespace: "academy" })
  private arraySchoolType: any;

  // STATE
  @State("school", { namespace: "academy" })
  private school: any;

  // INITIALIZATION
  private activeIndex: number | null = null;

  // WATCH
  @Watch("school.school_type")
  private onChangeSchoolType(school_type: any) {
    localStorage.setItem("school_type", school_type);
    
    this.onChangeSchool(school_type);
  }

  // METHOD
  private created() {
    const school_type_string = localStorage.getItem("school_type");
    if (school_type_string != null) {
      const school_type = parseInt(school_type_string);
      this.activeIndex = school_type;
      this.$store.state.academy.school.school_type = school_type;
    }
  }

  // ON CLICK
  private onClick(school_type: any) {
    this.activeIndex = school_type;
    this.$store.state.academy.school.school_type = school_type;
  }

  private onChangeSchool(schoolType: any) {
    this.actionLoadSchool({
      params: {
        schooltype: schoolType,
      },
      success: (response: any) => {
        // TODO
      },
      fail: (response: any) => {
        // TODO
      },
    });
  }

  private getLabel(item: any): string {
    if (this.$i18n.locale === "id") {
      return item.translation;
    }
    return item.name;
  }
}
